import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import Badge from "./Badge";
import Course from "./Course";
import Entry from "./Entry";

// tslint:disable:max-classes-per-file

class TrackProduct {

	@Field()
	public id: string;

	@Field()
	public required: boolean;

	/* @Field({entity: Entry, params: (data: any) => {
		if (data.language) {
			return {params: {language: data.language}};
		}
		return false;
	}}) */
	public entry: Entry;


	@Field({
		entity: Course,
		params: (data: any) => {
			if (data.language) {
				return {params: {language: data.language}};
			}
			return false;
		}
	})
	public course: Course;
}

export class ProgramProgress {
	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public completed: number;

	@Field()
	public total: number;
}

@Entity({one: "programTrack", many: "programTracks"})
export default class ProgramTrack {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public trackIconURL: string;

	@Field()
	public description: string;

	@Field({entity: Badge})
	public badges?: Badge[];

	@Field({entity: ProgramProgress})
	public progress?: ProgramProgress;

	// if true, disable launch button on next product until prev is completed
	@Field()
	public sequential: boolean;

	@Field()
	public credits?: number;

	@Field({
		entity: TrackProduct,
		includeIf: (data) => !!data.loadCourses
	})
	public products: TrackProduct[];
}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/ProgramTrack.ts